import { render, staticRenderFns } from "./SaveButton.vue?vue&type=template&id=41295a2c&"
import script from "./SaveButton.vue?vue&type=script&lang=js&"
export * from "./SaveButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports